import React from 'react';
import {
  BadgeCheck,
  Building2,
  Calendar,
  ClipboardCheck,
  ClipboardList,
  FileSignature,
  FolderCheck,
  HelpCircle,
  LayoutDashboard,
  MonitorSmartphone,
  PackageCheck,
  Phone,
  Rocket,
  Search,
  Send,
  Sparkles,
  Utensils,
  Wallet,
} from 'lucide-react';

const ICON_MAP: Record<string, React.FC<{ className?: string }>> = {
  send: Send,
  phone: Phone,
  calendar: Calendar,
  'file-signature': FileSignature,
  search: Search,
  'folder-check': FolderCheck,
  'layout-dashboard': LayoutDashboard,
  'badge-check': BadgeCheck,
  utensils: Utensils,
  sparkles: Sparkles,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  'building-2': Building2,
  wallet: Wallet,
  'monitor-smartphone': MonitorSmartphone,
  'package-check': PackageCheck,
  rocket: Rocket,
};

interface StageIconProps {
  icon: string;
  className?: string;
}

const StageIcon: React.FC<StageIconProps> = ({ icon, className }) => {
  const Cmp = ICON_MAP[icon] ?? HelpCircle;
  return <Cmp className={className} />;
};

export default StageIcon;
